"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEmailPreview = void 0;

var _reactRedux = require("react-redux");

var _gift = require("../store/gift/gift.selector");

var _useGiftContext2 = require("./useGiftContext");

var useEmailPreview = function useEmailPreview() {
  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      _useGiftContext$dashb = _useGiftContext.dashboardHost,
      dashboardHost = _useGiftContext$dashb === void 0 ? '' : _useGiftContext$dashb;

  var emailProviderId = (0, _reactRedux.useSelector)(_gift.getGiftEmailProviderId);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  return "".concat(dashboardHost, "/gift-email-preview/").concat(giftId, "/").concat(emailProviderId);
};

exports.useEmailPreview = useEmailPreview;